import React, { useEffect } from "react";

import { Link, useParams } from "react-router-dom";
import Banner from "../../Constant/Banner/Banner";
import { Products_Data } from "../../Constant/Data";

const ProductDetail = () => {
  const { id } = useParams();
  const currentProduct = Products_Data.find(
    (product) => product.product_id == id
  );
  const SubProducstsIDs = [
    "GCE1",
    "GCY7",
    "SSU6",
    "SAB2",
    "OPA3",
    "OPC5",
    "OPS9",
  ];
  const OnlyImsgedProductsNames = [
    "u_jack",
    "base_jack",
    "Industrial_rails",
    "used_and_new_rails",
    "copper_flat",
    "stainless_steel_pipe",
    "stainless_steel_plate",
    "aluminium_sections",
    "aluminium_sheet",
  ];
  const productName =
    currentProduct.product_name
      .replace(/_/g, " ")
      .trim()
      .charAt(0)
      .toUpperCase() + currentProduct.product_name.slice(1).replace(/_/g, " ");
  const isContainsSubProducts = SubProducstsIDs.includes(
    currentProduct.product_id
  );
  const SubProducts = currentProduct.sub_products || [];
  return (
    <>
      <Banner imagePath="productDetails.png" BannerText="Our Products" />
      <div className="container w-90">
        <div className="row">
          <h2 className="text-primary">{productName}</h2>
          {isContainsSubProducts ? (
            <div className="row p-lg-4">
              {SubProducts.map((subProduct) => (
                <div
                  className="col-12 col-lg-3 d-flex justify-content-center align-items-center mb-4 mb-lg-0"
                  key={subProduct.product_id}
                >
                  <div className="content">
                    {OnlyImsgedProductsNames.includes(
                      subProduct.product_name
                    ) ? (
                      // <div className="mg-fluid border-radius-2xl w-100">
                      //   <div className="content-overlay"></div>
                      //   <img
                      //     className="content-image"
                      //     src={`/images/ProductDetailsIMages/${subProduct.product_name}.jpg`}
                      //     style={{
                      //       objectFit: "cover",
                      //       border: "1px solid #ccc",
                      //     }}
                      //     alt={subProduct.product_name}
                      //   />
                      //   <div className="content-details fadeIn-bottom">
                      //     <h3 className="content-title">
                      //       {subProduct.product_name.charAt(0).toUpperCase() +
                      //         subProduct.product_name
                      //           .slice(1)
                      //           .replace(/_/g, " ")}
                      //     </h3>
                      //   </div>
                      // </div>
                      <>
                        <div className="content-overlay"></div>
                        <img
                          src={`/images/ProductDetailsIMages/${
                            subProduct.product_name ==
                            "cut_plates/special_size_plates"
                              ? "cut_plates&special_size_plates"
                              : subProduct.product_name
                          }.jpg`}
                          alt="Product"
                          className="img-fluid border-radius-2xl product-image w-100"
                          style={{
                            border: "1px solid #ccc",
                            cursor: "pointer",
                          }}
                        />
                        <div className="content-details fadeIn-bottom">
                          <h3 className="content-title">
                            {subProduct.product_name.charAt(0).toUpperCase() +
                              subProduct.product_name
                                .slice(1)
                                .replace(/_/g, " ")}
                          </h3>
                        </div>
                      </>
                    ) : (
                      <div className="mg-fluid border-radius-2xl w-100">
                        <Link to={"/ProductDetail/" + subProduct.product_id}>
                          <div className="content-overlay"></div>
                          <img
                            src={`/images/ProductDetailsIMages/${
                              subProduct.product_name ==
                              "cut_plates/special_size_plates"
                                ? "cut_plates&special_size_plates"
                                : subProduct.product_name
                            }.jpg`}
                            alt="Product"
                            className="img-fluid border-radius-2xl product-image w-100"
                            style={{
                              // objectFit: "cover",
                              border: "1px solid #ccc",
                              cursor: "pointer",
                            }}
                          />
                          <div className="content-details fadeIn-bottom">
                            <h3 className="content-title">
                              {subProduct.product_name.charAt(0).toUpperCase() +
                                subProduct.product_name
                                  .slice(1)
                                  .replace(/_/g, " ")}
                            </h3>
                          </div>
                        </Link>
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <p className="text-sm">
              <div className="row p-lg-4">
                <div className="col-12 col-lg-4 d-flex justify-content-center align-items-center mb-4 mb-lg-0">
                  <img
                    src={`/images/ProductDetailsIMages/${
                      currentProduct.product_name ==
                      "cut_plates/special_size_plates"
                        ? "cut_plates&special_size_plates"
                        : currentProduct.product_name
                    }.jpg`}
                    alt="Product"
                    className="img-fluid border-radius-2xl product-image w-100"
                    style={{
                      objectFit: "cover",
                      border: "1px solid #ccc",
                    }}
                  />
                </div>
                {/* <div className="col-8 d-flex flex-column justify-content-center align-items-center"> */}
                <div className="col-12 col-lg-8">
                  {/* table  */}
                  {currentProduct.product_rows != null ||
                  currentProduct.product_rows != undefined ? (
                    <div class="custom-table">
                      {currentProduct.product_rows
                        .split(",")
                        .map((row, index) => (
                          <div class="table-row" key={index}>
                            <div class="table-col-title">
                              {row.split(":")[0].trim()}
                            </div>
                            <div class="table-col-value">
                              {currentProduct[`value${index + 1}`] || "N/A"}
                            </div>
                          </div>
                        ))}
                      {/* <div class="table-row">
                    <div class="table-col-title">Name</div>
                    <div class="table-col-value">1.00 mm – 5.00 mm</div>
                  </div>
                  <div class="table-row">
                    <div class="table-col-title">Name</div>
                    <div class="table-col-value">Phosphated and oiled</div>
                  </div>
                  <div class="table-row">
                    <div class="table-col-title">Name</div>
                    <div class="table-col-value">
                      IS 4454 – Part I GR I, GR II, GR III
                    </div>
                  </div>
                  <div class="table-row">
                    <div class="table-col-title">Name</div>
                    <div class="table-col-value">0.30 mm – 2.10.00 mm</div>
                  </div>
                  <div class="table-row">
                    <div class="table-col-title">Name</div>
                    <div class="table-col-value">IS: 1835-1976</div>
                  </div>
                  <div class="table-row">
                    <div class="table-col-title">Name</div>
                    <div class="table-col-value">
                      Wire ropes for Marine, Oil and Gas, Structural, Cranes,
                      Fishing, Elevators applications
                    </div>
                  </div> */}
                    </div>
                  ) : (
                    <></>
                  )}
                  {/* Description */}
                  {/* <h4>Product Description</h4> */}

                  {currentProduct.product_name == "mild_steel_beam(ISMB)" ? (
                    <p>
                      <ul className="mt-3">
                        <li>
                          <span style={{ fontWeight: "bold" }}>
                            NPB (Narrow Parallel Beams) <br />
                          </span>
                          Dimensions (in mm): 180x90 to 600 x220
                          <br />
                          Galvanisation – As per requirement
                        </li>
                        <li>
                          <span style={{ fontWeight: "bold" }}>
                            WPB (Wide Parallel Beams)
                          </span>
                          <br />
                          Dimensions (in mm): 700x300x150 to 900x300x333
                        </li>
                        <li>
                          <span style={{ fontWeight: "bold" }}>
                            Universal Beams
                          </span>
                          <br />
                          Dimensions (in mm): 152X89X16 to 762X267X220
                        </li>
                        <li>
                          <span style={{ fontWeight: "bold" }}>
                            Universal Columns
                          </span>
                          <br />
                          Dimensions (in mm): 610X229X101
                        </li>
                      </ul>
                    </p>
                  ) : (
                    <></>
                  )}

                  {currentProduct.product_name == "crane_rails" ? (
                    <p>
                      <span style={{ fontWeight: "bold", fontSize: "1.2em" }}>
                        Track Rail Section
                        <br />
                      </span>
                      60E1, 60E2, 60E1A1 / ZU-1-60, IRS 52, UIC 54 sections as
                      per IRS-T-12 and EN-13674 IRS T-12-2009: Gr 880, R260, Gr
                      1080HH, 1175HT Class A, Class B, IU Rails EN 13674-1: R
                      200, R 220, R 260, R350HT
                    </p>
                  ) : (
                    <></>
                  )}

                  {currentProduct.product_name ==
                  "cut_plates/special_size_plates" ? (
                    <p>
                      <span style={{ fontWeight: "bold", fontSize: "1.2em" }}>
                        Any Thickness/size with(or)without holes available with
                        Laser/CNC cutting.
                        <br />
                      </span>
                    </p>
                  ) : (
                    <></>
                  )}
                </div>
              </div>
            </p>
          )}
        </div>
      </div>
    </>
  );
};

export default ProductDetail;
